module.exports = __webpack_public_path__ + "static/media/bt-entries-square.3a9a2909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/bt-entries-square.jpg
// module id = 683
// module chunks = 0